import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function LandingPage() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [scrolled, setScrolled] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) setMenuOpen(false);
    };
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveStep((prev) => (prev + 1) % 3);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  const goToCustomerRegister = () => navigate("/register?role=customer");
  const goToBarberRegister = () => navigate("/register?role=barber");
  const goToBrowseSalons = () => navigate("/shops");
  const goToBookAppointment = () => {
    if (user?.role === "customer") navigate("/shops");
    else navigate("/register?role=customer");
  };

  const waLink = "https://wa.me/919337782645?text=Hi%20TrimSpot%20Support%2C%20I%20need%20help%20with%20my%20booking.";

  return (
    <div style={styles.page}>

      {/* ── Navbar ── */}
      <nav style={{ ...styles.nav, ...(scrolled ? styles.navScrolled : {}) }}>
        <div style={styles.navInner}>
          <div style={styles.logo}>
            <span style={styles.logoIcon}>💈</span>
            <span style={styles.logoText}>TrimSpot</span>
          </div>

          {!isMobile && (
            <div style={styles.navLinks}>
              <a href="#how-it-works" style={styles.navLink}>How It Works</a>
              <a href="#features" style={styles.navLink}>Features</a>
              <a href="#pricing" style={styles.navLink}>Pricing</a>
              <button onClick={goToBrowseSalons} style={styles.navBrowseBtn}>🏪 Browse Salons</button>
              {!user && (
                <>
                  <button onClick={() => navigate("/login")} style={styles.navLoginBtn}>Login</button>
                  <button onClick={goToCustomerRegister} style={styles.navRegisterBtn}>Get Started Free</button>
                </>
              )}
              {user?.role === "barber" && (
                <button onClick={() => navigate("/dashboard")} style={styles.navRegisterBtn}>My Dashboard</button>
              )}
              {user?.role === "customer" && (
                <button onClick={() => navigate("/shops")} style={styles.navRegisterBtn}>Browse Salons</button>
              )}
            </div>
          )}

          {isMobile && (
            <button style={styles.hamburger} onClick={() => setMenuOpen(!menuOpen)}>
              {menuOpen ? "✕" : "☰"}
            </button>
          )}
        </div>

        {isMobile && menuOpen && (
          <div style={styles.mobileMenu}>
            <a href="#how-it-works" style={styles.mobileLink} onClick={() => setMenuOpen(false)}>How It Works</a>
            <a href="#features" style={styles.mobileLink} onClick={() => setMenuOpen(false)}>Features</a>
            <a href="#pricing" style={styles.mobileLink} onClick={() => setMenuOpen(false)}>Pricing</a>
            <button onClick={() => { goToBrowseSalons(); setMenuOpen(false); }} style={styles.mobileBtnBrowse}>
              🏪 Browse Salons
            </button>
            {!user && (
              <>
                <button onClick={() => { navigate("/login"); setMenuOpen(false); }} style={styles.mobileBtnOutline}>Login</button>
                <button onClick={() => { goToCustomerRegister(); setMenuOpen(false); }} style={styles.mobileBtnPrimary}>Create Free Account</button>
              </>
            )}
            {user?.role === "barber" && (
              <button onClick={() => { navigate("/dashboard"); setMenuOpen(false); }} style={styles.mobileBtnPrimary}>My Dashboard</button>
            )}
            {user?.role === "customer" && (
              <button onClick={() => { navigate("/my-bookings"); setMenuOpen(false); }}
                style={styles.mobileBtnPrimary}>📅 My Bookings</button>
            )}
          </div>
        )}
      </nav>

      {/* ── Hero Section ── */}
      <section style={styles.hero}>
        <div style={styles.heroBg} />
        <div style={styles.heroContent}>
          <div style={styles.heroBadge}>✂️ Odisha's Smartest Salon & Spa Booking Platform</div>
          <h1 style={styles.heroTitle}>
            Book Your Salon
            <span style={styles.heroTitleAccent}> Instantly</span>
          </h1>
          
          <p style={styles.heroSubtitle}>
            Find top-rated Salons near you, book instantly — no calls, no waiting!
          </p>
          <p style={styles.heroHomeNote}>
            🏠 Home Services Available — Salon & Spa at your doorstep!
          </p>

          <div style={styles.heroBtns}>
            <button onClick={goToBrowseSalons} style={styles.heroMainBtn}>🏪 Browse Salons</button>
            <button onClick={goToBookAppointment} style={styles.heroSecondBtn}>📅 Book Appointment</button>
            <button onClick={goToBarberRegister} style={styles.heroThirdBtn}>🏪 List My Shop</button>
          </div>

          <p style={styles.heroHint}>👆 Browse salons freely — login only when you book!</p>

          <div style={styles.heroStats}>
            <div style={styles.heroStat}>
              <span style={styles.heroStatNum}>100%</span>
              <span style={styles.heroStatLabel}>Free for Customers</span>
            </div>
            <div style={styles.heroStatDivider} />
            <div style={styles.heroStat}>
              <span style={styles.heroStatNum}>3 Min</span>
              <span style={styles.heroStatLabel}>To Book</span>
            </div>
            <div style={styles.heroStatDivider} />
            <div style={styles.heroStat}>
              <span style={styles.heroStatNum}>₹0</span>
              <span style={styles.heroStatLabel}>Online Payment</span>
            </div>
          </div>
        </div>

        {!isMobile && (
          <div style={styles.phoneMockup}>
            <div style={styles.phone}>
              <div style={styles.phoneScreen}>
                <div style={styles.phoneHeader}>
                  <span style={styles.phoneHeaderText}>💈 TrimSpot</span>
                </div>
                <div style={styles.phoneShopCard}>
                  <div style={styles.phoneShopIcon}>✂️</div>
                  <div>
                    <p style={styles.phoneShopName}>Raju Hair Salon</p>
                    <p style={styles.phoneShopCity}>📍 Brahmapur</p>
                    <p style={styles.phoneShopRating}>⭐ 4.8 · 120 reviews</p>
                  </div>
                </div>
                <div style={styles.phoneSlots}>
                  {["9:00 AM", "10:30 AM", "2:00 PM"].map((slot, i) => (
                    <div key={i} style={{ ...styles.phoneSlot, ...(i === 1 ? styles.phoneSlotActive : {}) }}>
                      {slot}
                    </div>
                  ))}
                </div>
                <div style={styles.phoneBookBtn}>Book Now ✓</div>
              </div>
            </div>
          </div>
        )}
      </section>

      {/* ── How It Works ── */}
      <section id="how-it-works" style={styles.section}>
        <div style={styles.sectionInner}>
          <p style={styles.sectionTag}>Simple Process</p>
          <h2 style={styles.sectionTitle}>Book in 3 Easy Steps</h2>
          <p style={styles.sectionSubtitle}>No calls, no waiting — just tap and go!</p>
          <div style={styles.stepsGrid}>
            {[
              { icon: "🔍", step: "01", title: "Find Your Salon", desc: "Search Salon shops in your city. See ratings, services, prices and timings." },
              { icon: "📅", step: "02", title: "Pick Your Slot", desc: "Choose your preferred service, date and available time slot instantly." },
              { icon: "✂️", step: "03", title: "Walk In & Get Served", desc: "Show up at your booked time. Get your appointment and pay directly to Salon." },
            ].map((item, i) => (
              <div key={i} style={{ ...styles.stepCard, ...(activeStep === i ? styles.stepCardActive : {}) }}>
                <div style={styles.stepNumber}>{item.step}</div>
                <div style={styles.stepIcon}>{item.icon}</div>
                <h3 style={styles.stepTitle}>{item.title}</h3>
                <p style={styles.stepDesc}>{item.desc}</p>
              </div>
            ))}
          </div>
          <div style={styles.sectionCta}>
            <button onClick={goToBrowseSalons} style={styles.sectionCtaBtn}>🏪 Browse Salons Near You →</button>
          </div>
        </div>
      </section>

      {/* ── Features ── */}
      <section id="features" style={{ ...styles.section, background: "#f9f9f9" }}>
        <div style={styles.sectionInner}>
          <p style={styles.sectionTag}>Why TrimSpot</p>
          <h2 style={styles.sectionTitle}>Everything You Need</h2>
          <div style={styles.featuresGrid}>
            {[
              { icon: "⚡", title: "Instant Booking", desc: "Book appointments in under 3 minutes. No phone calls needed!" },
              { icon: "📍", title: "Find Nearby", desc: "Discover the best Salon shops in your city with ratings and reviews." },
              { icon: "🎟️", title: "Exclusive Discounts", desc: "Get special coupon codes from Salons for amazing deals!" },
              { icon: "⭐", title: "Verified Reviews", desc: "Read genuine reviews from customers who actually visited the shop." },
              { icon: "💰", title: "Pay at Shop", desc: "No online payment needed. Pay directly to Salon after service!" },
              { icon: "📱", title: "Works on Mobile", desc: "Perfectly designed for your phone. Book from anywhere, anytime!" },
            ].map((feature, i) => (
              <div key={i} style={styles.featureCard}>
                <div style={styles.featureIcon}>{feature.icon}</div>
                <h3 style={styles.featureTitle}>{feature.title}</h3>
                <p style={styles.featureDesc}>{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── For Salons ── */}
      <section style={{ ...styles.section, background: "#1a1a2e" }}>
        <div style={styles.sectionInner}>
          <div style={{ ...styles.SalonSection, flexDirection: isMobile ? "column" : "row" }}>
            <div style={styles.SalonLeft}>
              <p style={{ ...styles.sectionTag, color: "#e94560" }}>For Salons</p>
              <h2 style={{ ...styles.sectionTitle, color: "white" }}>Grow Your Shop With TrimSpot</h2>
              <p style={{ ...styles.sectionSubtitle, color: "#aaa" }}>Get more customers, manage bookings easily and grow your business!</p>
              <div style={styles.SalonBenefits}>
                {[
                  "✅ Get discovered by new customers",
                  "✅ Manage all bookings from dashboard",
                  "✅ Reduce no-shows with confirmations",
                  "✅ Create coupon codes for promotions",
                  "✅ Track daily revenue & stats",
                  "✅ First 45 days completely FREE!",
                ].map((benefit, i) => (
                  <p key={i} style={styles.SalonBenefit}>{benefit}</p>
                ))}
              </div>
              <button onClick={goToBarberRegister} style={styles.SalonBtn}>List My Shop for Free →</button>
            </div>
            {!isMobile && (
              <div style={styles.SalonRight}>
                <div style={styles.dashboardMockup}>
                  <div style={styles.dashboardHeader}>✂️ Salon Dashboard</div>
                  <div style={styles.dashboardStats}>
                    {[
                      { label: "Today", value: "8", color: "#e94560" },
                      { label: "Revenue", value: "₹1,200", color: "#4caf50" },
                      { label: "Pending", value: "3", color: "#ff9800" },
                    ].map((stat, i) => (
                      <div key={i} style={styles.dashStat}>
                        <p style={{ ...styles.dashStatNum, color: stat.color }}>{stat.value}</p>
                        <p style={styles.dashStatLabel}>{stat.label}</p>
                      </div>
                    ))}
                  </div>
                  {["Rahul - 10:00 AM", "Suresh - 11:30 AM", "Amit - 2:00 PM"].map((booking, i) => (
                    <div key={i} style={styles.dashBooking}>
                      <span>👤 {booking}</span>
                      <span style={{ color: "#4caf50", fontSize: "12px" }}>✅ Confirmed</span>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* ── Pricing ── */}
      <section id="pricing" style={styles.section}>
        <div style={styles.sectionInner}>
          <p style={styles.sectionTag}>Simple Pricing</p>
          <h2 style={styles.sectionTitle}>Plans For Every Salon</h2>
          <p style={styles.sectionSubtitle}>Start free for 45 days. No credit card needed!</p>
          <div style={styles.pricingGrid}>
            {[
              { name: "Starter", price: "299", color: "#1a1a2e", features: ["20 bookings/month", "Basic profile", "WhatsApp notifications"], popular: false },
              { name: "Growth", price: "599", color: "#e94560", features: ["Unlimited bookings", "Customer reviews", "Analytics dashboard", "Appointment reminders"], popular: true },
              { name: "Premium", price: "999", color: "#ff9800", features: ["Everything in Growth", "Featured listing", "Loyalty program", "Priority support"], popular: false },
            ].map((plan, i) => (
              <div key={i} style={{ ...styles.pricingCard, ...(plan.popular ? styles.pricingCardPopular : {}) }}>
                {plan.popular && <div style={styles.popularBadge}>⭐ Most Popular</div>}
                <h3 style={styles.pricingName}>{plan.name}</h3>
                <div style={styles.pricingPrice}>
                  <span style={{ ...styles.pricingAmount, color: plan.color }}>₹{plan.price}</span>
                  <span style={styles.pricingPeriod}>/month</span>
                </div>
                <div style={styles.pricingFeatures}>
                  {plan.features.map((f, j) => (
                    <p key={j} style={styles.pricingFeature}>✓ {f}</p>
                  ))}
                </div>
                <button onClick={goToBarberRegister} style={{ ...styles.pricingBtn, background: plan.color }}>
                  Start Free Trial
                </button>
              </div>
            ))}
          </div>
          <p style={styles.pricingNote}>🎉 First 45 days FREE for all new Salons! No credit card required.</p>
        </div>
      </section>

      {/* ── CTA ── */}
      <section style={{ ...styles.section, background: "#e94560", padding: "60px 20px" }}>
        <div style={{ textAlign: "center" }}>
          <h2 style={{ fontSize: isMobile ? "1.8rem" : "2.5rem", color: "white", marginBottom: "16px" }}>
            Ready to Get Started?
          </h2>
          <p style={{ color: "rgba(255,255,255,0.8)", fontSize: "1rem", marginBottom: "32px" }}>
            Join TrimSpot today — free for customers, free trial for Salons!
          </p>
          <div style={{ display: "flex", gap: "16px", justifyContent: "center", flexWrap: "wrap" }}>
            <button onClick={goToBrowseSalons} style={styles.ctaBrowseBtn}>🏪 Browse Salons</button>
            <button onClick={goToBookAppointment} style={styles.ctaMainBtn}>📅 Book Appointment</button>
            <button onClick={goToBarberRegister} style={styles.ctaSecondBtn}>🏪 List My Shop</button>
          </div>
        </div>
      </section>

      {/* ── Footer ── */}
      <footer style={styles.footer}>
        <div style={styles.footerInner}>
          <div style={styles.footerLogo}>
            <span>💈</span>
            <span style={{ color: "white", fontWeight: "800", fontSize: "1.2rem" }}>TrimSpot</span>
          </div>
          <p style={styles.footerText}>Book Salon appointments online. Available across Odisha.</p>
          <div style={styles.footerLinks}>
            <button onClick={goToBrowseSalons} style={styles.footerLink}>Browse Salons</button>
            <button onClick={() => navigate("/login")} style={styles.footerLink}>Login</button>
            <button onClick={goToCustomerRegister} style={styles.footerLink}>Register</button>
            <button onClick={goToBarberRegister} style={styles.footerLink}>List My Shop</button>
          </div>
          <p style={styles.footerSupport}>
            💬 Need help?{" "}
            <a href={waLink} target="_blank" rel="noopener noreferrer" style={styles.footerSupportLink}>
              WhatsApp us at +91 93377 82645
            </a>
          </p>
          <p style={styles.footerCopy}>© 2026 TrimSpot. Made with ❤️ in Odisha</p>
        </div>
      </footer>

      {/* ── Floating WhatsApp Support Button ── */}
      <a href={waLink} target="_blank" rel="noopener noreferrer" style={styles.whatsappFloat}>
        <span style={{ fontSize: "20px" }}>💬</span>
        <span style={styles.whatsappFloatText}>Support</span>
      </a>

    </div>
  );
}

const styles = {
  page: { fontFamily: "'Segoe UI', sans-serif", overflowX: "hidden" },
  nav: { position: "fixed", top: 0, left: 0, right: 0, zIndex: 100, padding: "12px 16px", transition: "all 0.3s", background: "rgba(26,26,46,0.97)" },
  navScrolled: { background: "#1a1a2e", boxShadow: "0 2px 20px rgba(0,0,0,0.3)" },
  navInner: { maxWidth: "1100px", margin: "0 auto", display: "flex", justifyContent: "space-between", alignItems: "center" },
  logo: { display: "flex", alignItems: "center", gap: "8px" },
  logoIcon: { fontSize: "24px" },
  logoText: { fontSize: "1.3rem", fontWeight: "800", color: "white" },
  navLinks: { display: "flex", alignItems: "center", gap: "12px" },
  navLink: { color: "#ccc", textDecoration: "none", fontSize: "14px", fontWeight: "500" },
  navBrowseBtn: { background: "rgba(233,69,96,0.15)", border: "1px solid rgba(233,69,96,0.4)", color: "#e94560", padding: "8px 14px", borderRadius: "8px", cursor: "pointer", fontSize: "13px", fontWeight: "600" },
  navLoginBtn: { background: "none", border: "1px solid white", color: "white", padding: "8px 14px", borderRadius: "8px", cursor: "pointer", fontSize: "13px" },
  navRegisterBtn: { background: "#e94560", color: "white", border: "none", padding: "8px 14px", borderRadius: "8px", cursor: "pointer", fontSize: "13px", fontWeight: "bold" },
  hamburger: { background: "none", border: "1px solid #555", color: "white", fontSize: "20px", cursor: "pointer", padding: "6px 12px", borderRadius: "8px" },
  mobileMenu: { background: "#0d0d1a", padding: "16px", borderTop: "1px solid #333", display: "flex", flexDirection: "column", gap: "10px" },
  mobileLink: { color: "#ccc", textDecoration: "none", padding: "12px 16px", borderRadius: "8px", fontSize: "15px", background: "#1a1a2e", display: "block" },
  mobileBtnBrowse: { background: "rgba(233,69,96,0.15)", border: "1px solid rgba(233,69,96,0.4)", color: "#e94560", padding: "12px 16px", borderRadius: "8px", cursor: "pointer", fontSize: "15px", fontWeight: "600", textAlign: "left" },
  mobileBtnOutline: { background: "transparent", border: "1px solid white", color: "white", padding: "12px 16px", borderRadius: "8px", cursor: "pointer", fontSize: "15px", textAlign: "left" },
  mobileBtnPrimary: { background: "#e94560", border: "none", color: "white", padding: "12px 16px", borderRadius: "8px", cursor: "pointer", fontSize: "15px", fontWeight: "bold", textAlign: "left" },
  hero: { minHeight: "100vh", background: "#1a1a2e", display: "flex", alignItems: "center", padding: "100px 24px 60px", position: "relative", overflow: "hidden", flexWrap: "wrap", gap: "40px", justifyContent: "center" },
  heroBg: { position: "absolute", top: 0, left: 0, right: 0, bottom: 0, background: "radial-gradient(circle at 20% 50%, rgba(233,69,96,0.15) 0%, transparent 60%)", pointerEvents: "none" },
  heroContent: { maxWidth: "560px", position: "relative", zIndex: 1 },
  heroBadge: { display: "inline-block", background: "rgba(233,69,96,0.2)", color: "#e94560", padding: "6px 16px", borderRadius: "20px", fontSize: "13px", fontWeight: "bold", marginBottom: "20px" },
  heroTitle: { fontSize: "clamp(2rem, 6vw, 3.5rem)", fontWeight: "900", color: "white", lineHeight: 1.1, margin: "0 0 16px" },
  heroTitleAccent: { color: "#e94560" },
  heroSubtitle: { color: "#aaa", fontSize: "1rem", lineHeight: 1.7, marginBottom: "10px" },
  heroHomeNote: { color: "#81c784", fontSize: "1rem", lineHeight: 1.7, marginBottom: "28px", fontStyle: "italic", fontWeight: "500" },
  heroBtns: { display: "flex", gap: "10px", flexWrap: "wrap", marginBottom: "12px" },
  heroMainBtn: { background: "#e94560", color: "white", border: "none", padding: "13px 20px", borderRadius: "10px", cursor: "pointer", fontSize: "14px", fontWeight: "bold" },
  heroSecondBtn: { background: "rgba(255,255,255,0.1)", color: "white", border: "1px solid rgba(255,255,255,0.3)", padding: "13px 20px", borderRadius: "10px", cursor: "pointer", fontSize: "14px" },
  heroThirdBtn: { background: "transparent", color: "#e94560", border: "1px solid #e94560", padding: "13px 20px", borderRadius: "10px", cursor: "pointer", fontSize: "14px" },
  heroHint: { color: "#666", fontSize: "12px", marginBottom: "28px" },
  heroStats: { display: "flex", gap: "20px", alignItems: "center", flexWrap: "wrap" },
  heroStat: { display: "flex", flexDirection: "column", gap: "4px" },
  heroStatNum: { color: "white", fontWeight: "900", fontSize: "1.4rem" },
  heroStatLabel: { color: "#888", fontSize: "12px" },
  heroStatDivider: { width: "1px", height: "40px", background: "#333" },
  phoneMockup: { position: "relative", zIndex: 1 },
  phone: { width: "240px", background: "#0d0d1a", borderRadius: "30px", padding: "14px", boxShadow: "0 30px 80px rgba(0,0,0,0.5), 0 0 0 1px #333" },
  phoneScreen: { background: "#f5f5f5", borderRadius: "20px", overflow: "hidden" },
  phoneHeader: { background: "#1a1a2e", padding: "10px 14px" },
  phoneHeaderText: { color: "white", fontWeight: "bold", fontSize: "13px" },
  phoneShopCard: { display: "flex", gap: "10px", alignItems: "center", padding: "12px", background: "white", margin: "8px", borderRadius: "10px" },
  phoneShopIcon: { fontSize: "24px" },
  phoneShopName: { fontWeight: "bold", fontSize: "12px", margin: "0 0 2px" },
  phoneShopCity: { color: "#888", fontSize: "10px", margin: "0 0 2px" },
  phoneShopRating: { color: "#f5a623", fontSize: "10px", margin: 0 },
  phoneSlots: { display: "flex", gap: "6px", padding: "0 8px 8px", flexWrap: "wrap" },
  phoneSlot: { padding: "5px 8px", border: "1px solid #ddd", borderRadius: "6px", fontSize: "10px", background: "white" },
  phoneSlotActive: { background: "#e94560", color: "white", border: "1px solid #e94560" },
  phoneBookBtn: { margin: "0 8px 10px", background: "#e94560", color: "white", padding: "8px", borderRadius: "8px", textAlign: "center", fontSize: "12px", fontWeight: "bold" },
  section: { padding: "60px 24px" },
  sectionInner: { maxWidth: "1100px", margin: "0 auto" },
  sectionTag: { color: "#e94560", fontWeight: "bold", fontSize: "13px", textTransform: "uppercase", letterSpacing: "2px", marginBottom: "12px" },
  sectionTitle: { fontSize: "clamp(1.6rem, 4vw, 2.4rem)", fontWeight: "900", color: "#1a1a2e", marginBottom: "12px" },
  sectionSubtitle: { color: "#777", fontSize: "1rem", marginBottom: "40px" },
  sectionCta: { textAlign: "center", marginTop: "32px" },
  sectionCtaBtn: { background: "#e94560", color: "white", border: "none", padding: "14px 28px", borderRadius: "10px", cursor: "pointer", fontSize: "15px", fontWeight: "bold" },
  stepsGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: "20px" },
  stepCard: { background: "white", borderRadius: "16px", padding: "28px", boxShadow: "0 4px 20px rgba(0,0,0,0.06)", border: "2px solid transparent", transition: "all 0.3s" },
  stepCardActive: { border: "2px solid #e94560", transform: "translateY(-4px)", boxShadow: "0 12px 30px rgba(233,69,96,0.15)" },
  stepNumber: { fontSize: "2.5rem", fontWeight: "900", color: "#f0f0f0", lineHeight: 1, marginBottom: "8px" },
  stepIcon: { fontSize: "1.8rem", marginBottom: "10px" },
  stepTitle: { fontSize: "1.1rem", fontWeight: "bold", color: "#1a1a2e", marginBottom: "8px" },
  stepDesc: { color: "#777", lineHeight: 1.6, fontSize: "14px" },
  featuresGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: "16px" },
  featureCard: { background: "white", borderRadius: "14px", padding: "20px", boxShadow: "0 2px 12px rgba(0,0,0,0.06)" },
  featureIcon: { fontSize: "1.8rem", marginBottom: "10px" },
  featureTitle: { fontSize: "1rem", fontWeight: "bold", color: "#1a1a2e", marginBottom: "6px" },
  featureDesc: { color: "#777", fontSize: "13px", lineHeight: 1.6 },
  SalonSection: { display: "flex", gap: "40px", alignItems: "center" },
  SalonLeft: { flex: 1 },
  SalonBenefits: { marginBottom: "24px" },
  SalonBenefit: { color: "#ccc", fontSize: "14px", marginBottom: "10px" },
  SalonBtn: { background: "#e94560", color: "white", border: "none", padding: "14px 24px", borderRadius: "10px", cursor: "pointer", fontSize: "15px", fontWeight: "bold" },
  SalonRight: { flex: 1 },
  dashboardMockup: { background: "#0d0d1a", borderRadius: "16px", padding: "20px", border: "1px solid #333" },
  dashboardHeader: { color: "white", fontWeight: "bold", fontSize: "15px", marginBottom: "16px", paddingBottom: "12px", borderBottom: "1px solid #333" },
  dashboardStats: { display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "10px", marginBottom: "14px" },
  dashStat: { background: "#1a1a2e", borderRadius: "10px", padding: "10px", textAlign: "center" },
  dashStatNum: { fontSize: "1.2rem", fontWeight: "bold", margin: "0 0 4px" },
  dashStatLabel: { color: "#888", fontSize: "11px", margin: 0 },
  dashBooking: { display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 10px", background: "#1a1a2e", borderRadius: "8px", marginBottom: "6px", fontSize: "12px", color: "#ccc" },
  pricingGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: "20px", marginBottom: "20px" },
  pricingCard: { background: "white", borderRadius: "16px", padding: "24px", boxShadow: "0 4px 20px rgba(0,0,0,0.08)", border: "2px solid #f0f0f0", position: "relative" },
  pricingCardPopular: { border: "2px solid #e94560", boxShadow: "0 8px 30px rgba(233,69,96,0.2)" },
  popularBadge: { position: "absolute", top: "-14px", left: "50%", transform: "translateX(-50%)", background: "#e94560", color: "white", padding: "4px 16px", borderRadius: "20px", fontSize: "12px", fontWeight: "bold", whiteSpace: "nowrap" },
  pricingName: { fontSize: "1.2rem", fontWeight: "bold", color: "#1a1a2e", marginBottom: "10px" },
  pricingPrice: { display: "flex", alignItems: "baseline", gap: "4px", marginBottom: "16px" },
  pricingAmount: { fontSize: "2.2rem", fontWeight: "900" },
  pricingPeriod: { color: "#888", fontSize: "14px" },
  pricingFeatures: { marginBottom: "20px" },
  pricingFeature: { color: "#555", fontSize: "13px", marginBottom: "8px" },
  pricingBtn: { width: "100%", padding: "12px", color: "white", border: "none", borderRadius: "10px", cursor: "pointer", fontSize: "14px", fontWeight: "bold" },
  pricingNote: { textAlign: "center", color: "#888", fontSize: "14px" },
  ctaBrowseBtn: { background: "white", color: "#e94560", border: "none", padding: "14px 24px", borderRadius: "10px", cursor: "pointer", fontSize: "14px", fontWeight: "bold" },
  ctaMainBtn: { background: "rgba(255,255,255,0.15)", color: "white", border: "2px solid white", padding: "14px 24px", borderRadius: "10px", cursor: "pointer", fontSize: "14px", fontWeight: "bold" },
  ctaSecondBtn: { background: "transparent", color: "white", border: "2px solid rgba(255,255,255,0.5)", padding: "14px 24px", borderRadius: "10px", cursor: "pointer", fontSize: "14px" },
  footer: { background: "#0d0d1a", padding: "40px 24px" },
  footerInner: { maxWidth: "1100px", margin: "0 auto", textAlign: "center" },
  footerLogo: { display: "flex", alignItems: "center", gap: "8px", justifyContent: "center", marginBottom: "12px", fontSize: "20px" },
  footerText: { color: "#666", fontSize: "14px", marginBottom: "16px" },
  footerLinks: { display: "flex", gap: "20px", justifyContent: "center", marginBottom: "16px", flexWrap: "wrap" },
  footerLink: { background: "none", border: "none", color: "#888", cursor: "pointer", fontSize: "14px" },
  footerSupport: { color: "#666", fontSize: "13px", marginBottom: "12px" },
  footerSupportLink: { color: "#25D366", textDecoration: "none", fontWeight: "600" },
  footerCopy: { color: "#555", fontSize: "13px" },
  whatsappFloat: { position: "fixed", bottom: "24px", right: "20px", zIndex: 999, background: "#25D366", color: "white", borderRadius: "50px", padding: "12px 18px", display: "flex", alignItems: "center", gap: "8px", textDecoration: "none", boxShadow: "0 4px 20px rgba(37,211,102,0.4)", fontWeight: "bold", fontSize: "14px" },
  whatsappFloatText: { fontSize: "13px", fontWeight: "bold" },
};